import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface AgeRequirementsProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const AgeRequirements: React.FC<AgeRequirementsProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { age_requirements: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: {
        age_requirements: data.additional_info?.age_requirements || null,
      },
    })) as ApiResponse
  }

  const options: SelectOption[] = [
    { value: null, label: "Select age requirements..." },
    { value: "21+", label: "21+" },
    { value: "18+", label: "18+" },
    { value: "all_ages", label: "All Ages" },
    { value: "show_dependent", label: "Differs by show" },
  ]

  const fieldData = {
    field: "additional_info.age_requirements",
    name: "ageRequirements",
    label: "Age Requirements",
    placeholder: "Select age requirements",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
      onSubmit={customOnSubmit}
    />
  )
}
